@if (isAdmin) {
  <sm-toolbar>
    <p-button severity="warn" icon="fas fa-cog" label="Administration" (onClick)="adminClick()">
    </p-button>
    <p-button severity="warn" icon="fas fa-cog" label="Administration (Grundschule)" routerLink="/enaio-certificates/grade-book/admin/{{_SchoolType.elementary}}/{{year}}/{{isHalfYear}}">
    </p-button>
    <p-button severity="warn" icon="fas fa-cog" label="Administration (Gesamtschule)" routerLink="/enaio-certificates/grade-book/admin/{{_SchoolType.secondary}}/{{year}}/{{isHalfYear}}">
    </p-button>
    <p-select class="width200" id="year" [options]="years"
      [(ngModel)]="year" (onChange)="selectedYearChanged()">
    </p-select>
  </sm-toolbar>
}
<p-card header="Bitte wählen Sie eine Klasse aus">
    <app-school-class-list [schoolClasses]="schoolClasses" baseUrl="/enaio-certificates/grade-book/class" [isHalfYear]="isHalfYear"></app-school-class-list>    
</p-card>
